/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import VantaTopology from './VantaBackground'
import Carousel from './Carousel'
import './AuthPageStyle.scss'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <VantaTopology>
      {/* <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
        }}
      > */}
      {/* begin::Content */}

      <div
        className='w-100 h-100 d-md-flex justify-content-center align-items-center flex-column 
      flex-column-fluid  '
      >
        {/* begin::Logo */}
        {/* <a href='/' className='mb-12'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/default.svg')} className='h-45px' />
          </a> */}
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='custom-box shadow-sm  p-lg-8 mx-auto glass-card g-3 d-md-flex custom-login-form '>
          <Outlet />
          <div className='img-wrapper d-none d-md-block'>
            {/* <img
              src={toAbsoluteUrl('/media/login-bg/blockchain-img.png')}
              alt='Logo'
              className='w-100 h-100 object-cover custom-rounded'
              loading='lazy'
            /> */}
            <Carousel />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>

      {/* end::Content */}
      {/* begin::Footer */}
      {/* <div className='d-flex flex-center flex-column-auto p-10'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <a href='/' className='text-muted text-hover-primary px-2'>
              خانه
            </a>

            <a href='#' className='text-muted text-hover-primary px-2'>
              فروشگاه
            </a>

            <a href='/about' className='text-muted text-hover-primary px-2'>
              درباره ما
            </a>

            <a href='/contact' className='text-muted text-hover-primary px-2'>
              تماس با ما
            </a>
          </div>
        </div> */}
      {/* end::Footer */}
      {/* </div> */}
    </VantaTopology>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
